<template>
  <div class="getKey notranslate">
    <div v-if="key" class="key">{{ key }}</div>
    <div v-else-if="message" class="messageBox">
      <p class="message">
        {{ locale[`message_smartkey_${message}`] || message }}
        <button type="button" class="btnRefresh" @click="init"></button>
      </p>
      <div v-if="messageLog" class="messageLog mt5">
        <p
          v-for="(message, index) in messageLog"
          :key="index">
          {{ message }}
        </p>
      </div>
      <!-- 재인증 요청 또는 잘못된 요청정보를 가져온 경우(로컬에 저장된 정보와 파라미터 정보가 상이함) 다시 인증하러 가야함 -->
      <div v-if="message === 'reauth' || message === 'invalid_request'" class="mt30">
        <button type="button"
          class="btn btnFull btnRound btnWhite btnReAuth"
          @click="goAuth">
          {{locale.go_auth}}
        </button>
      </div>
    </div>
    <div v-else class="key loading">{{ locale.data_loading }}</div>
  </div>
</template>

<script>
export default {
  computed: {
    locale () {
      return this.$store.state.system.locale.data
    },
    authInfo () {
      return this.$store.getters['authentication/getAuthInfo']
    },
    getMobilekeyInfo () {
      return this.$store.getters['guest/getMobilekeyInfo']
    }
  },
  created () {
    this.init()
  },
  data () {
    return {
      key: '',
      message: '',
      messageLog: null,
      requestActiveKey: 0
    }
  },
  methods: {
    init () {
      this.key = ''
      this.message = ''
      this.messageLog = null
      this.requestActiveKey = 0
      this.$store.dispatch('guest/getMobileKey').then((res) => {
        if (res && res.status && res.status === 200) {
          const sendResult = res.data && res.data.message
          const key = sendResult && sendResult.mobileKey
          if (key) {
            this.key = this.addSpaces(key)
            this.$emit('setStatus', 200)
            if (!sendResult.activeKey) {
              this.getActiveMobileKey()
            }
          } else {
            const errorCode = res && res.data && res.data.message && res.data.message.code || 500
            const errorMessage = this.getResultData(errorCode)
            this.message = errorMessage
            this.$emit('setStatus', errorCode)
          }
        } else {
          const errorCode = res && res.message && res.message.code || 500
          const errorMessage = this.getResultData(errorCode)
          this.message = errorMessage
          if (errorCode === 401) {
            this.messageLog = res.message.reason && res.message.reason.map(x => x.message.replace(/\"/g, '"'))
          } else {
            // system error
          }
          this.$emit('setStatus', errorCode)
        }
      })
    },
    /**
     * 활성화키 가져오기
     * 인증 후 모바일키10자리 외에 물리키4자리를 활성화 하는데
     * 비동기로 인해 get-key 요청시 바로 활성화가 되지 않고
     * 모바일키로 리턴되는 경우가 있음, 이때 활성화키를 다시 호출
     */
    getActiveMobileKey () {
      const getMobilekeyInfo = this.getMobilekeyInfo
      this.requestActiveKey += 1
      this.$store.dispatch('guest/checkInvalidMobileKey', getMobilekeyInfo).then((res) => {
        const sendResult = res.data && res.data.message
        const key = sendResult && sendResult.mobileKey
        if (key) {
          this.key = this.addSpaces(key)
          this.$emit('setStatus', 200)
        }
        if (!sendResult.activeKey && this.requestActiveKey < 3) {
          setTimeout(() => {
            this.getActiveMobileKey()
          }, 600)
        }
      })
    },
    getResultData (code) {
      return this.$store.getters['guest/getSmartkeyResultData'](code)
    },
    addSpaces (str) { // 4개단위로 씌어쓰기
      str = `${str}`
      return str.replace(/(.{4})/g, '$1 ');
    },
    goAuth () { // 재인증이 필요해 다시 인증페이지로 이동해야함
      this.$router.push({
        name: 'mobilekeyAuth'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.key {
  font-weight: bold;
}
.messageBox {
  font-size: 0;
}
.message {
  position: relative;
  padding-left: 40px;
  padding-right: 40px;
  font-size: 28px;
}
.btnRefresh {
  position: absolute;
  top: 50%;
  right: 4px;
  width: 32px;
  height: 32px;
  margin-top: -16px;
  border: 1px solid $color-lgrey;
  border-radius: 4px;
  background-color: $color-white;
  &:after {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    background: url('~@/assets/img/refresh-ccw.png') 50% 50% / 18px no-repeat;
    opacity: 0.5;
  }
}
.messageLog {
  font-size: 14px;
}
.loading,
.btnReAuth {
  font-size: 20px;
  font-weight: normal;
}
</style>
